import styled from 'styled-components';
import DriverDayStopSeparator from './component';

import { skinsGroupage } from 'modules/journey/card/styled/groupageBackground';

export default styled(DriverDayStopSeparator)`
  height: 32px;
  background-color: var(--grey200);
  width: 100%;

  .cell {
    &__skin {
      background: ${(props) => skinsGroupage[props.skin]};
      height: 100%;
      opacity: 0.5;
    }
  }

  .container {
    background-color: var(--grey100);
    width: 884px;
    display: flex;
    display: flex;
    align-items: center;
    height: 100%;
  }

  .distance {
    color: var(--grey700);
  }

  .stop-timings {
    padding: 0;
    position: relative;
    height: 100%;

    &:before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      background-color: var(--primary300);
      left: 14px;
      height: 16px;
    }

    &:after {
      content: '';
      width: 4px;
      position: absolute;
      top: 15px;
      background-color: var(--primary300);
      left: 14px;
      bottom: 0;
    }

    &__is_empty {
      &:before {
        background-color: transparent;
        border: 2px dotted var(--grey300);
        top: -2px;
        height: 31px;
      }
      &:after {
        content: none;
      }
      .stop-timings__time {
        background-color: var(--grey300);
        color: var(--grey800);
      }
    }

    &__time {
      height: 16px;
      background-color: var(--primary300);
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      position: absolute;
      top: 8px;
      border-radius: 2px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 4px;
      transform: translateX(calc(-50% + 17px));
    }
  }
`;
